import React from 'react'

import Link from 'components/base/Link'

import { Tag } from 'screens/Blog/types'

import { Props } from './types'

import { Tags } from './styles'

const PostTagsList: React.FC<Props> = ({ tags }): React.ReactElement|null => (tags?.length && (
  <Tags>
    <strong>Tags: </strong>
    {tags.map((tag: Tag, i: number) => <React.Fragment key={tag.slug}><Link to={`/blog/tags/${tag.slug}`}>#{tag.name}</Link>{i < tags.length - 1 ? ', ' :''}</React.Fragment>)}
  </Tags>
)) || null

export default PostTagsList
